import React from 'react';

const MindMapDrawing = ({ drawing, isActive }) => {
  const { points, color, strokeWidth } = drawing;
  
  if (points.length < 2) return null;

  // Create smooth path from points
  const pathData = points.reduce((acc, point, index) => {
    if (index === 0) {
      return `M ${point.x} ${point.y}`;
    }
    // Use quadratic curves for smoother lines
    const prev = points[index - 1];
    const midX = (prev.x + point.x) / 2;
    const midY = (prev.y + point.y) / 2;
    return `${acc} Q ${prev.x} ${prev.y} ${midX} ${midY}`;
  }, '');

  return (
    <path
      d={pathData}
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity={isActive ? 0.7 : 1}
      style={{ 
        filter: 'drop-shadow(0 0 2px rgba(255,255,255,0.2))',
        pointerEvents: 'none',
      }}
    />
  );
};

export default MindMapDrawing;
